export default __webpack_public_path__ + "143d6c62fb16a32460e5fd1b109838d8.png";